/* I&C · motion layer · House feature (rd-feature.liquid)
   Photo box: curtain reveal, one warm light sweep, then (desktop) a scroll-linked parallax (box moves 8% slower than the page)
   and a slow ken-burns drift on the image, both written as inline transforms from one rAF loop that only runs while the
   section is on screen and the tab visible. Eyebrow letters and headline lines (measured at reveal time) rise out of clip
   masks; index rows stagger in while their hairlines draw; hovering/focusing a row counts its price up. Phone: entrance only.
   Single IIFE, no globals, nothing under prefers-reduced-motion. */
(function () {
  'use strict';
  var MQ_REDUCE = '(prefers-reduced-motion: reduce)', MQ_DESK = '(min-width: 901px)', MQ_POINTER = '(hover: hover) and (pointer: fine)';
  var RATE = 0.08, KB_PERIOD = 17000, ENTER_MS = 2600, COUNT_MS = 760, HOVER_SCALE = 1.035;
  var now = function () { return window.performance && performance.now ? performance.now() : Date.now(); };

  function mk(tag, cls, hidden) {
    var el = document.createElement(tag); el.className = cls;
    if (hidden) el.setAttribute('aria-hidden', 'true');
    return el;
  }
  function textNodes(el) {
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), out = [], n;
    while ((n = w.nextNode())) if (/\S/.test(n.nodeValue)) out.push(n);
    return out;
  }
  /* wrap every word of el in span.rd-m-w > span.rd-m-w__in, keeping <em> etc. intact; returns the outer spans */
  function splitWords(el) {
    var out = [];
    textNodes(el).forEach(function (t) {
      var frag = document.createDocumentFragment();
      t.nodeValue.split(/(\s+)/).forEach(function (p) {
        if (!p) return;
        if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(' ')); return; }
        var w = mk('span', 'rd-m-w'), i = mk('span', 'rd-m-w__in');
        i.textContent = p; w.appendChild(i); frag.appendChild(w); out.push(w);
      });
      t.parentNode.replaceChild(frag, t);
    });
    return out;
  }
  /* wrap every non-space character of el in span.rd-m-c with --i = its index */
  function splitChars(el) {
    var k = 0;
    textNodes(el).forEach(function (t) {
      var frag = document.createDocumentFragment();
      t.nodeValue.split('').forEach(function (ch) {
        if (/\s/.test(ch)) { frag.appendChild(document.createTextNode(' ')); return; }
        var c = mk('span', 'rd-m-c'); c.textContent = ch; c.style.setProperty('--i', k++); frag.appendChild(c);
      });
      t.parentNode.replaceChild(frag, t);
    });
    return k;
  }
  /* group word spans into lines by their top edge (one layout read per word, done once at reveal) */
  function assignLines(words) {
    var line = -1, last = -1e9;
    for (var k = 0; k < words.length; k++) {
      var top = words[k].getBoundingClientRect().top;
      if (top - last > 6) { line++; last = top; }
      words[k].style.setProperty('--i', line);
    }
    return line + 1;
  }
  /* "$1,234.50" / "€1.234,50" / "1 234 kr" -> numeric value + the pieces needed to re-format it */
  function parsePrice(s) {
    var m = /\d[\d.,  ]*\d|\d/.exec(s); if (!m) return null;
    var num = m[0], i = Math.max(num.lastIndexOf('.'), num.lastIndexOf(',')), decSep = '', dec = 0;
    if (i > -1 && num.length - i - 1 !== 3) { decSep = num.charAt(i); dec = num.length - i - 1; }
    var intPart = decSep ? num.slice(0, i) : num, thou = (/[^\d]/.exec(intPart) || [''])[0];
    var v = parseFloat(intPart.replace(/[^\d]/g, '') + (decSep ? '.' + num.slice(i + 1) : ''));
    if (isNaN(v)) return null;
    return { s: m.index, e: m.index + num.length, v: v, dec: dec, decSep: decSep, thou: thou };
  }
  function fmt(v, p) {
    var parts = v.toFixed(p.dec).split('.');
    if (p.thou) parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, p.thou);
    return parts[0] + (p.dec ? p.decSep + parts[1] : '');
  }
  function countUp(p) {
    if (!p._rdMRaf) p._rdMOrig = p.textContent; else cancelAnimationFrame(p._rdMRaf);
    var orig = p._rdMOrig, info = parsePrice(orig), start = now();
    if (!info) return;
    (function step() {
      var k = Math.min(1, (now() - start) / COUNT_MS), e = 1 - Math.pow(1 - k, 3);
      p.textContent = k >= 1 ? orig : orig.slice(0, info.s) + fmt(info.v * (0.82 + 0.18 * e), info) + orig.slice(info.e);
      p._rdMRaf = k < 1 ? requestAnimationFrame(step) : 0;
    })();
  }

  function init() {
    var feat = document.querySelector('.rd .feature');
    if (!feat) return;
    var section = (feat.closest && feat.closest('.section')) || feat.parentNode;
    if (section.hasAttribute('data-rd-m-feature')) return;
    if (!window.matchMedia || window.matchMedia(MQ_REDUCE).matches || !('IntersectionObserver' in window)) return;
    var media = feat.querySelector('.feature__media'), body = feat.querySelector('.feature__body');
    var img = media && media.querySelector('img');
    if (!media || !body) return;
    section.setAttribute('data-rd-m-feature', '');
    var h2 = body.querySelector('.h2'), eyebrow = body.querySelector('.eyebrow'), list = body.querySelector('.index-list');
    var desk = window.matchMedia(MQ_DESK).matches, pointer = window.matchMedia(MQ_POINTER).matches;

    /* decor */
    media.appendChild(mk('span', 'rd-m-feature__sweep', true));
    var glow = null;
    if (desk) { glow = mk('span', 'rd-m-feature__glow', true); feat.insertBefore(glow, feat.firstChild); }

    /* text splitting (originals restored once the entrance has played) */
    var h2Orig = h2 ? h2.innerHTML : '', eyeOrig = eyebrow ? eyebrow.innerHTML : '';
    var words = h2 ? splitWords(h2) : [];
    if (eyebrow) {
      /* letters go into an aria-hidden span; a visually-hidden copy keeps the eyebrow readable by assistive tech meanwhile */
      var sr = mk('span', 'rd-m-sr'), vis = mk('span', '', true);
      sr.textContent = eyebrow.textContent;
      while (eyebrow.firstChild) vis.appendChild(eyebrow.firstChild);
      splitChars(vis); eyebrow.appendChild(sr); eyebrow.appendChild(vis);
    }

    /* arm: pre-states apply from here on */
    section.classList.add('rd-m-feature'); section.classList.add('is-arming');
    if (desk && img) section.classList.add('is-live');
    var disarm = function () { section.classList.remove('is-arming'); };
    requestAnimationFrame(function () { requestAnimationFrame(disarm); });

    var t0 = 0;
    function reveal() {
      disarm();
      var lines = assignLines(words); /* the rect reads also flush the un-armed style before is-in lands */
      if (!words.length) void section.offsetWidth; /* no headline: force that flush so the pre-states still transition */
      t0 = now();
      section.classList.add('is-in');
      setTimeout(function () {
        if (h2) h2.innerHTML = h2Orig;
        if (eyebrow) eyebrow.innerHTML = eyeOrig;
      }, 400 + lines * 180 + 1800);
    }
    var inIO = new IntersectionObserver(function (es) {
      for (var k = 0; k < es.length; k++) if (es[k].isIntersecting) { inIO.disconnect(); reveal(); return; }
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.04 });
    inIO.observe(section);

    /* index rows: price counts up on hover / focus */
    if (list) {
      Array.prototype.forEach.call(list.querySelectorAll('a'), function (a) {
        var p = a.querySelector('.p'); if (!p) return;
        if (pointer) a.addEventListener('mouseenter', function () { countUp(p); });
        a.addEventListener('focus', function () { countUp(p); });
      });
    }

    if (!desk || !img) return;

    /* desktop loop: parallax on the box (+ glow), ken-burns / entrance / hover scale on the image */
    var live = false, onScreen = false, raf = 0, top = 0, h = 0, vh = 0, hoverT = 1, hoverC = 1, lastImg = '', lastBox = '';
    function measure() {
      vh = window.innerHeight;
      var r = section.getBoundingClientRect();
      top = r.top + (window.pageYOffset || document.documentElement.scrollTop || 0); h = r.height;
    }
    function tick() {
      raf = 0;
      if (!live) return;
      var t = now(), y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var py = -RATE * (top + h / 2 - (y + vh / 2));
      var e = t0 ? Math.min(1, (t - t0) / ENTER_MS) : 0; e = 1 - Math.pow(1 - e, 3);
      hoverC += (hoverT - hoverC) * 0.045;
      var ph = t / KB_PERIOD * Math.PI * 2, kb = 1.035 + 0.03 * Math.sin(ph);
      var dx = 0.9 * Math.sin(ph * 0.63 + 1.2), dy = 0.6 * Math.cos(ph * 0.47);
      var sImg = 'translate3d(' + dx.toFixed(2) + '%,' + dy.toFixed(2) + '%,0) scale(' + ((1 + 0.09 * (1 - e)) * kb * hoverC).toFixed(4) + ')';
      if (sImg !== lastImg) { img.style.transform = sImg; lastImg = sImg; }
      var sBox = 'translate3d(0,' + py.toFixed(1) + 'px,0)';
      if (sBox !== lastBox) { media.style.transform = sBox; if (glow) glow.style.transform = sBox; lastBox = sBox; }
      raf = requestAnimationFrame(tick);
    }
    function sync() {
      var want = onScreen && !document.hidden;
      if (want && !live) { live = true; measure(); if (!raf) raf = requestAnimationFrame(tick); }
      else if (!want) live = false;
    }
    var liveIO = new IntersectionObserver(function (es) { onScreen = es[es.length - 1].isIntersecting; sync(); }, { rootMargin: '25% 0px' });
    liveIO.observe(section);
    document.addEventListener('visibilitychange', sync);
    var mqReduce = window.matchMedia(MQ_REDUCE), onReduce = function (e) { if (e.matches) { onScreen = false; liveIO.disconnect(); sync(); } };
    if (mqReduce.addEventListener) mqReduce.addEventListener('change', onReduce); else if (mqReduce.addListener) mqReduce.addListener(onReduce);
    window.addEventListener('resize', measure, { passive: true });
    window.addEventListener('load', measure);
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(document.body);
    if (pointer) {
      media.addEventListener('mouseenter', function () { hoverT = HOVER_SCALE; });
      media.addEventListener('mouseleave', function () { hoverT = 1; });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
